import styled, { css } from "styled-components";

import type { AnnotationPointKind } from "./types";

export type AnnotationPointMarkerGlyphVariant = "control" | "point" | "preview";

const MarkerGlyph = styled.i<{
  $kind: AnnotationPointKind;
  $variant: AnnotationPointMarkerGlyphVariant;
}>`
  position: relative;
  display: inline-block;
  width: ${({ $variant }) =>
    $variant === "point" ? "1.45rem" : $variant === "preview" ? "0.65rem" : "1rem"};
  height: ${({ $variant }) =>
    $variant === "point" ? "1.45rem" : $variant === "preview" ? "0.65rem" : "1rem"};
  flex: 0 0 auto;

  &::before,
  &::after {
    position: absolute;
    top: 50%;
    left: 50%;
    box-sizing: border-box;
    background: currentColor;
    content: "";
  }

  ${({ $kind, $variant, theme }) =>
    $kind === "include"
      ? css`
          &::before {
            width: var(--c6-annotation-marker-size);
            height: var(--c6-annotation-marker-size);
            border: ${$variant === "preview" ? "1px" : "2px"} solid ${theme.color.text.onControl};
            border-radius: 50%;
            transform: translate(-50%, -50%);
          }

          &::after {
            display: none;
          }
        `
      : css`
          &::before,
          &::after {
            width: var(--c6-annotation-marker-size);
            height: ${$variant === "preview" ? "1px" : "2px"};
            border-radius: 999px;
            box-shadow: 0 0 0 ${$variant === "preview" ? "0.5px" : "1px"}
              ${theme.color.text.onControl};
          }

          &::before {
            transform: translate(-50%, -50%) rotate(45deg);
          }

          &::after {
            transform: translate(-50%, -50%) rotate(-45deg);
          }
        `}

  --c6-annotation-marker-size: ${({ $variant }) =>
    $variant === "point" ? "0.9rem" : $variant === "preview" ? "0.48rem" : "0.78rem"};
`;

export function AnnotationPointMarkerGlyph({
  kind,
  variant = "point",
}: {
  kind: AnnotationPointKind;
  variant?: AnnotationPointMarkerGlyphVariant;
}) {
  return (
    <MarkerGlyph
      $kind={kind}
      $variant={variant}
      aria-hidden="true"
      data-annotation-point-marker={kind}
    />
  );
}
